// @flow

import { FetchApi } from "../model/fetch";
import { BaseService } from "./base-service";
import { Suburb } from "../model/suburb";

const EMAIL_REGEX = /^\S+@\S+\.\S+$/;
const POSTCODE_REGEX = /^[0-9]{4,4}$/;
const ACCOUNT_NUMBER_REGEX = /^[0-9]+$/;
const SPECIAL_CHARACTERS_NAME = /[`~!#$%^&*=+[\]{}\\|;:'"<>,/?@]/;
const SPECIAL_CHARACTERS_MAIL = /[`~!#$%^&*=+[\]{}\\|;:'"<>,/?]/;

const MIN_ACCOUNT_NUMBER_LENGTH = 4;
const MAX_ACCOUNT_NUMBER_LENGTH = 10;

export class ValidationService extends BaseService {
    constructor(
        fetchApi: FetchApi,
        options: {
            basepath: string
        }
    ) {
        super(fetchApi, options);
    }
    validateName = (name: string) => {
        const hasName = !!name;
        const isFormatValid =
            !hasName ||
            !this._hasSpecialCharacters(name, SPECIAL_CHARACTERS_NAME);
        const success = hasName && isFormatValid;
        return {
            success: success ? "success" : "fail",
            required: !hasName,
            format: !isFormatValid
        };
    };
    validateEmail = (email: string) => {
        const hasEmail = !!email;
        const isEmailFormatCorrect =
            !hasEmail ||
            (this._isEmailFormatCorrect(email) &&
                !this._hasSpecialCharacters(email, SPECIAL_CHARACTERS_MAIL));
        const isEmailSuccess = hasEmail && isEmailFormatCorrect;
        const result = {
            success: isEmailSuccess ? "success" : "fail",
            required: !hasEmail,
            format: !isEmailFormatCorrect
        };
        return result;
    };
    validatePasswordForLogin = (password: string) => {
        const hasPassword = !!password;
        const isPasswordSuccess = hasPassword;
        const result = {
            success: isPasswordSuccess ? "success" : "fail",
            required: !hasPassword
        };
        return result;
    };
    validatePassword = (password: string) => {
        const hasPassword = !!password;
        const isPasswordComplexEnough = this._isPasswordComplex(password);
        const isPasswordSuccess = hasPassword && isPasswordComplexEnough;
        const result = {
            success: isPasswordSuccess ? "success" : "fail",
            required: !hasPassword,
            complex: hasPassword && !isPasswordComplexEnough
        };
        return result;
    };
    validatePassword2 = (password1: string, password2: string) => {
        const hasPassword = !!password2;
        const isPasswordComplexEnough = this._isPasswordComplex(password2);
        const isMatch = password1 === password2;
        const isPasswordSuccess =
            hasPassword && isPasswordComplexEnough && isMatch;
        const result = {
            success: isPasswordSuccess ? "success" : "fail",
            required: !hasPassword,
            match: hasPassword && !isMatch,
            complex: hasPassword && isMatch && !isPasswordComplexEnough
        };
        return result;
    };
    validateForRecover = (email: string) => {
        const hasEmail = !!email;
        const isEmailFormatCorrect =
            !hasEmail || this._isEmailFormatCorrect(((email: any): string));
        const isEmailSuccess = hasEmail && isEmailFormatCorrect;
        const result = {
            success: isEmailSuccess ? "success" : "fail",
            required: !hasEmail,
            format: !isEmailFormatCorrect
        };
        return result;
    };
    validateSuburb = (suburb: Suburb) => {
        const hasPostcode = suburb && suburb.codeNumber;
        const postcodeRegValid =
            hasPostcode && POSTCODE_REGEX.test(suburb.codeNumber);
        const hasSuburbAndState = suburb && suburb.suburb && suburb.state;
        const success = hasPostcode && postcodeRegValid && hasSuburbAndState;
        return {
            success: success ? "success" : "fail",
            required: !success
        };
    };
    validateAccountNumber = (accountNumber: string) => {
        const hasAccountNumber = !!accountNumber;
        const success =
            !hasAccountNumber || this._isAccountNumberValid(accountNumber);
        return {
            success: success ? "success" : "fail",
            format: !success
        };
    };

    _isEmailFormatCorrect = (email: string) => {
        if (EMAIL_REGEX.test(email)) {
            return true;
        }
        return false;
    };
    _isPasswordComplex = (password: string) => {
        const hasUpperLetter = /[A-Z]/.test(password);
        const hasLowerLetter = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const correctLength = password.length >= 7;

        return hasUpperLetter && hasLowerLetter && hasNumber && correctLength;
    };
    _isAccountNumberValid = (accountNumber: string) => {
        return (
            ACCOUNT_NUMBER_REGEX.test(accountNumber) &&
            accountNumber.length >= MIN_ACCOUNT_NUMBER_LENGTH &&
            accountNumber.length <= MAX_ACCOUNT_NUMBER_LENGTH
        );
    };
    _hasSpecialCharacters = (str: string, reg: RegExp) => {
        return reg.test(str);
    };
}
